import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "./CmsPage";

const LINKS = [["/doctors", "Find a doctor"], ["/diagnostics", "Book a test"], ["/medicines", "Order medicines"], ["/membership", "Memberships"], ["/contact", "Contact us"]];

export default function NotFoundPage() {
  useSeo({ meta_title: "Page not found | 6SigmaCare", meta_description: "The page you requested does not exist.", noindex: true });
  return (
    <section className="max-w-xl mx-auto px-4 py-24 text-center space-y-5" data-testid="not-found-page">
      <p className="text-xs font-bold tracking-widest text-[#3B8271]">ERROR 404</p>
      <h1 className="font-serif-luxury text-4xl sm:text-5xl font-bold text-[#0D3B2E]">We couldn't find that page</h1>
      <p className="text-sm text-gray-600">The link may be outdated or the page may have moved. Try one of these instead:</p>
      <nav className="flex flex-wrap justify-center gap-2">{LINKS.map(([to, l]) => <Link key={to} to={to} data-testid={`not-found-link-${to.slice(1)}`} className="px-4 py-2 rounded-2xl border border-[#0D3B2E]/20 text-xs font-bold text-[#0D3B2E] hover:bg-[#0D3B2E] hover:text-white transition-colors">{l}</Link>)}</nav>
      <Link to="/" data-testid="not-found-home" className="inline-block text-xs underline text-gray-500">Back to home</Link>
    </section>
  );
}
